import * as Victory from 'victory'
export const VictoryBar = Victory.VictoryBar;
export const VictoryChart = Victory.VictoryChart;
export const VictoryTooltip = Victory.VictoryTooltip;
export const VictoryAxis = Victory.VictoryAxis;
export const VictoryLegend = Victory.VictoryLegend;
export const VictoryStack = Victory.VictoryStack;
export const VictoryTheme = Victory.VictoryTheme;
export const VictoryLabel = Victory.VictoryLabel;
export const VictoryLine = Victory.VictoryLine;